import React from "react";
import notFoundIcon from '../../../assets/images/empty_item_box.png'

const NoContentFound = ({title="No content found!", imgUrl=notFoundIcon}) => {
    return (
        <div className="no-content-found">
            <img src={imgUrl} alt="not found"/>
            <div>{title}</div>
        </div>
    )
}
export default NoContentFound;